// extracted by mini-css-extract-plugin
export default {"container":"welcomeScreen_container__DDPV+","fade":"welcomeScreen_fade__HiKLw","logo":"welcomeScreen_logo__NaXnx","message":"welcomeScreen_message__RromB"};